import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/client/legal/forms/targetedFinancialInstrumentsForm';

export const InformationAboutOperationsFields = () => {
  const { t } = useTranslation();

  return (
    <GridFields>
      <Field.Quantity
        fullWidth
        showRequiredMark
        label={t(
          `client.legal.targetedFinancialInstruments.informationAboutOperations.expectedMonthlyTradeQuantity.label`
        )}
        name="targetedFinancialInstruments.expectedMonthlyTradeQuantity"
        placeholder={t(
          `client.legal.targetedFinancialInstruments.informationAboutOperations.expectedMonthlyTradeQuantity.placeholder`
        )}
      />
      <Field.Quantity
        fullWidth
        showRequiredMark
        label={t(
          `client.legal.targetedFinancialInstruments.informationAboutOperations.expectedYearlyTradeQuantity.label`
        )}
        name="targetedFinancialInstruments.expectedYearlyTradeQuantity"
        placeholder={t(
          `client.legal.targetedFinancialInstruments.informationAboutOperations.expectedYearlyTradeQuantity.placeholder`
        )}
      />
    </GridFields>
  );
};
